'use client';

import { TIMEZONE_COOKIE_NAME } from '@utils/time-utils';
import { useEffect } from 'react';

const ONE_YEAR_IN_SECONDS = 60 * 60 * 24 * 365;

function readCookie(name: string): string | undefined {
  const prefix = `${name}=`;
  return document.cookie
    .split('; ')
    .find(row => row.startsWith(prefix))
    ?.slice(prefix.length);
}

/** Persist the device IANA zone so SSR date/greeting match the phone clock. */
export function TimeZoneSync() {
  useEffect(() => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (!timeZone || readCookie(TIMEZONE_COOKIE_NAME) === timeZone) return;

    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${TIMEZONE_COOKIE_NAME}=${timeZone}; path=/; max-age=${ONE_YEAR_IN_SECONDS}; SameSite=Lax${secure}`;
  }, []);

  return null;
}
